import React from 'react';
import { ContentLoader } from '@zapier/common-components';

export const ChangePlanSummarySkeleton = () => (
  <ContentLoader height="231px">
    <rect height="231" rx="0" ry="0" width="100%" x="0" y="0" />
  </ContentLoader>
);
